export const TREATMENT_GOAL_KEY = 'treatment_goal'
export const TREATMENT_GOAL_BETTER_ERECTIONS = 'better_erections'
export const TREATMENT_GOAL_LAST_LONGER = 'last_longer'
export const TREATMENT_GOAL_CONFIDENCE_IN_BED = 'confidence_in_bed'
export const TREATMENT_GOAL_ALL = 'all_of_the_above'

export const AD_COPY_1_KEY = 'ad_copy_1'

export const SEX_LIFE_DISRUPTIONS_KEY = 'sex_life_disruptions'
export const SEX_LIFE_DISRUPTIONS_OFTEN = 'often'
export const SEX_LIFE_DISRUPTIONS_OCCASIONALLY = 'occasionally'
export const SEX_LIFE_DISRUPTIONS_RARELY = 'rarely'

export const ED_AD_COPY_KEY = 'EdAdCopy'
export const ED_FACTS_1_KEY = 'EdFacts'

export const IIEF_1_KEY = 'iief1'
export const IIEF_2_KEY = 'iief2'
export const IIEF_3_KEY = 'iief3'
export const IIEF_4_KEY = 'iief4' // does not have 4
export const IIEF_5_KEY = 'iief5' // does not have 4

// Have you ever taken prescription medication in the past to help improve your erections?
export const HAVE_TAKEN_PRESCRIPTION_MEDICATION_KEY =
  'have_taken_prescription_medication'

// Which of the following medications have you used to improve your erections in the past?
export const WHICH_ERECTION_MEDICATIONS_KEY = 'which_erection_medications'
export const WHICH_ERECTION_MEDICATIONS_SILDENAFIL = 'sildenafil'
export const WHICH_ERECTION_MEDICATIONS_TADALAFIL_DAILY = 'tadalafil_daily'
export const WHICH_ERECTION_MEDICATIONS_TADALAFIL_ON_DEMAND =
  'tadalafil_on_demand'
export const WHICH_ERECTION_MEDICATIONS_OTHER = 'other'
const WHICH_ERECTION_MEDICATIONS_ANSWERS = new Set([
  WHICH_ERECTION_MEDICATIONS_SILDENAFIL,
  WHICH_ERECTION_MEDICATIONS_TADALAFIL_DAILY,
  WHICH_ERECTION_MEDICATIONS_TADALAFIL_ON_DEMAND,
  WHICH_ERECTION_MEDICATIONS_OTHER,
])

// Tell us about the medications you have used to improve your erections in the past?
export const OTHER_ERECTION_MEDICATIONS_DETAILS_KEY =
  'other_erection_medications_details'

// Which dose of Sildenafil (Viagra or generic) worked well for you?
export const SILDENAFIL_DOSE_KEY = 'sildenafil_dose'
export const SILDENAFIL_DOSE_25_MG = '25mg'
export const SILDENAFIL_DOSE_50_MG = '50mg'
export const SILDENAFIL_DOSE_100_MG = '100mg'
export const SILDENAFIL_DOSE_NONE = 'none'
const SILDENAFIL_DOSE_ANSWERS = new Set([
  SILDENAFIL_DOSE_25_MG,
  SILDENAFIL_DOSE_50_MG,
  SILDENAFIL_DOSE_100_MG,
  SILDENAFIL_DOSE_NONE,
])

// Which dose of daily Tadalafil (Cialis or generic) worked well for you?
export const DAILY_TADALAFIL_DOSE_KEY = 'daily_tadalafil_dose'
export const DAILY_TADALAFIL_DOSE_5_MG = '5mg'
export const DAILY_TADALAFIL_DOSE_NONE = 'none'
const DAILY_TADALAFIL_DOSE_ANSWERS = new Set([
  DAILY_TADALAFIL_DOSE_5_MG,
  DAILY_TADALAFIL_DOSE_NONE,
])

// Which dose of Tadalafil (Cialis or generic) before sexual activity worked well for you?
export const ON_DEMAND_TADALAFIL_DOSE_KEY = 'on_demand_tadalafil_dose'
export const ON_DEMAND_TADALAFIL_DOSE_10_MG = '5mg'
export const ON_DEMAND_TADALAFIL_DOSE_20_MG = '5mg'
export const ON_DEMAND_TADALAFIL_DOSE_NONE = 'none'
const ON_DEMAND_TADALAFIL_DOSE_ANSWERS = new Set([
  ON_DEMAND_TADALAFIL_DOSE_10_MG,
  ON_DEMAND_TADALAFIL_DOSE_20_MG,
  ON_DEMAND_TADALAFIL_DOSE_NONE,
])

// Are you interested in trying "Sildenafil (Viagra or generic)" again?
export const INTERESTED_IN_TRYING_SILDENAFIL_AGAIN_KEY =
  'interested_in_trying_sildenafil_again'

// Are you interested in trying "Tadalafil (Cialis or generic) - every day" again?
export const INTERESTED_IN_TRYING_TADALAFIL_DAILY_AGAIN_KEY =
  'interested_in_trying_tadalafil_daily_again'

// Are you interested in trying "Tadalafil (Cialis or generic) - only before sexual activity"
// again?
export const INTERESTED_IN_TRYING_TADALAFIL_ON_DEMAND_AGAIN_KEY =
  'interested_in_trying_tadalafil_on_demand_again'
export const INTERESTED_IN_TRYING_SAME_DOSE = 'interested_in_same_dose'
export const INTERESTED_IN_TRYING_HIGHER_DOSE = 'interested_in_higher_dose'
export const INTERESTED_IN_TRYING_LOWER_DOSE = 'interested_in_lower_dose'
export const NOT_INTERESTED_IN_TRYING_AGAIN = 'not_interested_in_trying_again'
const INTERESTED_IN_TRYING_AGAIN_ANSWERS = new Set([
  INTERESTED_IN_TRYING_SAME_DOSE,
  INTERESTED_IN_TRYING_HIGHER_DOSE,
  INTERESTED_IN_TRYING_LOWER_DOSE,
  NOT_INTERESTED_IN_TRYING_AGAIN,
])

// When do you want to take your medication?
export const MEDICATION_FREQUENCY_PREFERENCE_KEY =
  'medication_frequency_preference'
export const MEDICATION_FREQUENCY_PREFERENCE_DAILY = 'daily'
export const MEDICATION_FREQUENCY_PREFERENCE_BEFORE_SEX = 'before_sex'
export const MEDICATION_FREQUENCY_PREFERENCE_NONE = 'none'
const MEDICATION_FREQUENCY_PREFERENCE_ANSWERS = new Set([
  MEDICATION_FREQUENCY_PREFERENCE_DAILY,
  MEDICATION_FREQUENCY_PREFERENCE_BEFORE_SEX,
  MEDICATION_FREQUENCY_PREFERENCE_NONE,
])

// How many uses per month do you anticipate?
export const DOSE_PER_MONTH_KEY = 'dose_per_month'
const DOSE_PER_MONTH_ANSWERS = new Set([
  '10x',
  '8x',
  '6x',
  '4x',
  '16x',
  '14x',
  '12x',
])

// Weight and height questions
export const BODY_COMPOSITION_KEY = 'body_composition'
export const WEIGHT_KEY = 'weight'
export const HEIGHT_KEY = 'height'

// Date of birth question
export const DATE_OF_BIRTH_KEY = 'date_of_birth'

// Assigned sex question
export const ASSIGNED_SEX_AT_BIRTH_KEY = 'assigned_sex_at_birth'
export const ASSIGNED_SEX_AT_BIRTH_MALE = 'male'
export const ASSIGNED_SEX_AT_BIRTH_FEMALE = 'female'

// Do you have any of the following symptoms?\
export const LOW_T_SYMPTOMS_KEY = 'low_t_symptoms'
export const LOW_T_SYMPTOM_LOW_ENERGY = 'low_energy'
export const LOW_T_SYMPTOM_LOW_MOTIVATION = 'low_motivation'
export const LOW_T_SYMPTOM_DECREASED_PHYSICAL_ENDURANCE =
  'decreased_physical_endurance'
export const LOW_T_SYMPTOM_DECREASED_PHYSICAL_STRENGTH =
  'decreased_physical_strength'
export const LOW_T_SYMPTOM_DAYTIME_SLEEPINESS = 'daytime_sleepiness'
export const LOW_T_SYMPTOM_NONE = 'none'
const LOW_T_SYMPTOMS_ANSWERS = new Set([
  LOW_T_SYMPTOM_LOW_ENERGY,
  LOW_T_SYMPTOM_LOW_MOTIVATION,
  LOW_T_SYMPTOM_DECREASED_PHYSICAL_ENDURANCE,
  LOW_T_SYMPTOM_DECREASED_PHYSICAL_STRENGTH,
  LOW_T_SYMPTOM_DAYTIME_SLEEPINESS,
  LOW_T_SYMPTOM_NONE,
])

// Have you experienced any of the following symptoms in the last 6 months?
export const CHEST_PAIN_SYMPTOMS_KEY = 'chest_pain_symptoms'
export const CHEST_PAIN_SYMPTOMS_CLIMBING_STAIRS = 'climbing_stairs'
export const CHEST_PAIN_SYMPTOMS_SEXUAL_ACTIVITY = 'sexual_activity'
export const CHEST_PAIN_SYMPTOMS_FAINTING = 'fainting'
export const CHEST_PAIN_SYMPTOMS_NONE = 'none'
const CHEST_PAIN_SYMPTOMS_ANSWERS = new Set([
  CHEST_PAIN_SYMPTOMS_CLIMBING_STAIRS,
  CHEST_PAIN_SYMPTOMS_SEXUAL_ACTIVITY,
  CHEST_PAIN_SYMPTOMS_FAINTING,
  CHEST_PAIN_SYMPTOMS_NONE,
])

export const CHEST_PAIN_SYMPTOMS_DETAILS_KEY = 'chest_pain_symptom_details'

// Have you ever been diagnosed with or prescribed medication for any of the following symptoms?
export const DIAGNOSED_WITH_KEY = 'diagnosed_with'
export const DIAGNOSED_WITH_ABNORMAL_BLOOD_PRESSURE = 'abnormal_blood_pressure'
export const DIAGNOSED_WITH_BLOOD_DISORDER = 'blood_disorder'
export const DIAGNOSED_WITH_GASTROINTESTINAL_DISORDER =
  'gastrointestinal_disorder'
export const DIAGNOSED_WITH_KIDNEY_PROBLEMS = 'kidney_problems'
export const DIAGNOSED_WITH_CIRCULATION_PROBLEMS = 'circulation_problems'
export const DIAGNOSED_WITH_EYE_CONDITIONS = 'eye_conditions'
export const DIAGNOSED_WITH_PENIS_CONDITIONS = 'penis_conditions'
export const DIAGNOSED_WITH_BRAIN_PROBLEMS = 'brain_problems'
export const DIAGNOSED_WITH_CHRONIC_MEDICAL_CONDITIONS =
  'chronic_medical_conditions'
export const DIAGNOSED_WITH_NONE = 'none'
const DIAGNOSED_WITH_ANSWERS = new Set([
  DIAGNOSED_WITH_ABNORMAL_BLOOD_PRESSURE,
  DIAGNOSED_WITH_BLOOD_DISORDER,
  DIAGNOSED_WITH_GASTROINTESTINAL_DISORDER,
  DIAGNOSED_WITH_KIDNEY_PROBLEMS,
  DIAGNOSED_WITH_CIRCULATION_PROBLEMS,
  DIAGNOSED_WITH_EYE_CONDITIONS,
  DIAGNOSED_WITH_PENIS_CONDITIONS,
  DIAGNOSED_WITH_BRAIN_PROBLEMS,
  DIAGNOSED_WITH_CHRONIC_MEDICAL_CONDITIONS,
  DIAGNOSED_WITH_NONE,
])

// Which of these have you experienced? (when abnormal blood pressure was selected)
export const ABNORMAL_BLOOD_PRESSURE_TYPE_KEY = 'abnormal_blood_pressure_type'
export const ABNORMAL_BLOOD_PRESSURE_TYPE_DIABETES = 'diabetes'
export const ABNORMAL_BLOOD_PRESSURE_TYPE_HIGH_BP = 'high_bp'
export const ABNORMAL_BLOOD_PRESSURE_TYPE_LOW_BP = 'low_bp'
export const ABNORMAL_BLOOD_PRESSURE_TYPE_HIGH_CHOLESTEROL = 'high_cholesterol'
export const ABNORMAL_BLOOD_PRESSURE_TYPE_OTHER = 'other'
const ABNORMAL_BLOOD_PRESSURE_TYPE_ANSWERS = new Set([
  ABNORMAL_BLOOD_PRESSURE_TYPE_DIABETES,
  ABNORMAL_BLOOD_PRESSURE_TYPE_HIGH_BP,
  ABNORMAL_BLOOD_PRESSURE_TYPE_LOW_BP,
  ABNORMAL_BLOOD_PRESSURE_TYPE_HIGH_CHOLESTEROL,
  ABNORMAL_BLOOD_PRESSURE_TYPE_OTHER,
])

// Do you take any medication to manage those conditions?
export const ABNORMAL_BLOOD_PRESSURE_MEDICATION_KEY = 'abnormal_bp_medication'
export const ABNORMAL_BLOOD_PRESSURE_MEDICATION_DETAILS_KEY =
  'abnormal_bp_medication_details'

// Explain in details about other condition
export const ABNORMAL_BLOOD_PRESSURE_OTHER_DETAILS_KEY =
  'abnormal_bp_other_details'

// Which of these have you experienced? (when blood disorder was selected)
export const BLOOD_DISORDER_TYPE_KEY = 'blood_disorder_type'
export const BLOOD_DISORDER_TYPE_BLOOD_DISEASES = 'blood_diseases'
export const BLOOD_DISORDER_TYPE_HIV = 'hiv_aids'
export const BLOOD_DISORDER_TYPE_OTHER = 'other'
const BLOOD_DISORDER_ANSWERS = new Set([
  BLOOD_DISORDER_TYPE_BLOOD_DISEASES,
  BLOOD_DISORDER_TYPE_HIV,
  BLOOD_DISORDER_TYPE_OTHER,
])

// Which of the following blood conditions do you have?
export const BLOOD_DISEASE_TYPE_KEY = 'blood_disease_type'
export const BLOOD_DISEASE_TYPE_SICKLE_CELL = 'sickle_cell'
export const BLOOD_DISEASE_TYPE_CLOTTING = 'clotting'
export const BLOOD_DISEASE_TYPE_OTHER = 'other'
const BLOOD_DISEASE_ANSWERS = new Set([
  BLOOD_DISEASE_TYPE_SICKLE_CELL,
  BLOOD_DISEASE_TYPE_CLOTTING,
  BLOOD_DISEASE_TYPE_OTHER,
])

// Detail question about the blood disease
export const BLOOD_DISEASE_TYPE_SICKLE_CELL_DETAILS_KEY = 'sickle_cell_details'
export const BLOOD_DISEASE_TYPE_CLOTTING_DETAILS_KEY = 'clotting_details'
export const BLOOD_DISEASE_TYPE_OTHER_DETAILS_KEY = 'other_details'

// Do you take any medication to manage your HIV/AIDS?
export const HIV_AIDS_MEDICATION_KEY = 'hiv_aids_medication'
export const HIV_AIDS_MEDICATION_DETAILS_KEY = 'hiv_aids_medication_details'

// Details question about other blood disorders
export const BLOOD_DISORDER_OTHER_DETAILS_KEY = 'blood_disorder_other'

// Which of these have you experienced? (when gastro intestinal disorder was selected)
export const GASTRO_INTESTINAL_DISORDER_TYPE_KEY =
  'gastro_intestinal_disorder_type'
export const GASTRO_INTESTINAL_DISORDER_TYPE_LIVER_DISEASES = 'liver_diseases'
export const GASTRO_INTESTINAL_DISORDER_TYPE_GASTRO_CONDITIONS =
  'gastrointestinal_conditions'
const GASTRO_INTESTINAL_DISORDER_ANSWERS = new Set([
  GASTRO_INTESTINAL_DISORDER_TYPE_LIVER_DISEASES,
  GASTRO_INTESTINAL_DISORDER_TYPE_GASTRO_CONDITIONS,
])

// Do you currently have any of the following liver diseases or conditions?
export const LIVER_DISEASE_TYPE_KEY = 'live_disease_type'
export const LIVER_DISEASE_CIRRHOSIS = 'cirrhosis'
export const LIVER_DISEASE_FATTY_LIVER = 'fatty_liver'
export const LIVER_DISEASE_HEPATITIS = 'hepatitis'
export const LIVER_DISEASE_LIVER_TRANSPLANT = 'liver_transplant'
export const LIVER_DISEASE_OTHER = 'other'
const LIVER_DISEASE_ANSWERS = new Set([
  LIVER_DISEASE_CIRRHOSIS,
  LIVER_DISEASE_FATTY_LIVER,
  LIVER_DISEASE_HEPATITIS,
  LIVER_DISEASE_LIVER_TRANSPLANT,
  LIVER_DISEASE_OTHER,
])

// Tell us more about your liver problems. (if cirrhosis or hepatitis was selected)
export const LIVER_FUNCTION_KEY = 'liver_function'
export const LIVER_FUNCTION_NORMAL = 'normal'
export const LIVER_FUNCTION_MILDLY_IMPAIRED = 'mildly_impaired'
export const LIVER_FUNCTION_POOR = 'poor'
export const LIVER_FUNCTION_UNKNOWN = 'unknown'
const LIVER_FUNCTION_ANSWERS = new Set([
  LIVER_FUNCTION_NORMAL,
  LIVER_FUNCTION_MILDLY_IMPAIRED,
  LIVER_FUNCTION_POOR,
  LIVER_FUNCTION_UNKNOWN,
])

// When was your liver transplant?
export const LIVER_TRANSPLANT_DATE_KEY = 'liver_transplant_date'
export const LIVER_TRANSPLANT_DATE_LESS_THAN_3_MONTHS_AGO =
  'less_than_3_months_ago'
export const LIVER_TRANSPLANT_DATE_MORE_THAN_3_MONTHS_AGO =
  'more_than_3_months_ago'
const LIVER_TRANSPLANT_DATE_ANSWERS = new Set([
  LIVER_TRANSPLANT_DATE_LESS_THAN_3_MONTHS_AGO,
  LIVER_TRANSPLANT_DATE_MORE_THAN_3_MONTHS_AGO,
])

// Is your transplant functioning well?
export const LIVER_TRANSPLANT_FUNCTION_KEY = 'liver_transplant_function'

// Details about other liver diseases
export const LIVER_DISEASE_OTHER_DETAILS_KEY = 'liver_disease_other_details'

// Which of the following stomach or other gastrointestinal conditions do you have?
export const GASTRO_INTESTINAL_CONDITION_TYPE_KEY =
  'gastro_intestinal_condition_type'
export const GASTRO_INTESTINAL_CONDITION_TYPE_INTESTINAL_ULCER =
  'intestinal_ulcer'
export const GASTRO_INTESTINAL_CONDITION_TYPE_OTHER = 'other'
const GASTRO_INTESTINAL_CONDITION_ANSWERS = new Set([
  GASTRO_INTESTINAL_CONDITION_TYPE_INTESTINAL_ULCER,
  GASTRO_INTESTINAL_CONDITION_TYPE_OTHER,
])

// There have been postmarketing reports of GI bleeding after PDE5i treatment in men with
// gastrointestinal ulcers.
// However, it is not known if bleeding was caused by PDE5i in these cases. Do you want to
// continue?
export const INTESTINAL_ULCER_ACCEPT_NOTICE_KEY =
  'intestinal_ulcer_accept_notice'

// Details about other gastrointestinal condition
export const GASTRO_INTESTINAL_CONDITION_TYPE_OTHER_DETAILS_KEY =
  'gastro_intestinal_condition_other_details'

// Which of these have you experienced? (when kidney problem was selected)
export const KIDNEY_PROBLEM_TYPE_KEY = 'kidney_problem_type'
export const KIDNEY_PROBLEM_TYPE_KIDNEY_STONES = 'kidney_stones'
export const KIDNEY_PROBLEM_TYPE_END_STAGE_RENAL_DISEASE =
  'end_stage_renal_disease'
export const KIDNEY_PROBLEM_TYPE_KIDNEY_TRANSPLANT = 'kidney_transplant'
export const KIDNEY_PROBLEM_TYPE_CHRONIC_KIDNEY_DISEASES =
  'kidney_chronic_diseases'
export const KIDNEY_PROBLEM_TYPE_OTHER = 'other'
const KIDNEY_PROBLEM_TYPE_ANSWERS = new Set([
  KIDNEY_PROBLEM_TYPE_KIDNEY_STONES,
  KIDNEY_PROBLEM_TYPE_END_STAGE_RENAL_DISEASE,
  KIDNEY_PROBLEM_TYPE_KIDNEY_TRANSPLANT,
  KIDNEY_PROBLEM_TYPE_CHRONIC_KIDNEY_DISEASES,
  KIDNEY_PROBLEM_TYPE_OTHER,
])

// When was your kidney transplant?
export const KIDNEY_TRANSPLANT_DATE_KEY = 'kidney_transplant_date'
export const KIDNEY_TRANSPLANT_DATE_LESS_THAN_3_MONTHS_AGO =
  'less_than_3_months_ago'
export const KIDNEY_TRANSPLANT_DATE_MORE_THAN_3_MONTHS_AGO =
  'more_than_3_months_ago'
const KIDNEY_TRANSPLANT_DATE_ANSWERS = new Set([
  KIDNEY_TRANSPLANT_DATE_LESS_THAN_3_MONTHS_AGO,
  KIDNEY_TRANSPLANT_DATE_MORE_THAN_3_MONTHS_AGO,
])

// Which of the following represents your kidney disease?
export const KIDNEY_DISEASE_STAGE_KEY = 'kidney_disease_stage'
export const KIDNEY_DISEASE_STAGE_1_2 = 'stage_1_2'
export const KIDNEY_DISEASE_STAGE_3_4 = 'stage_3_4'
export const KIDNEY_DISEASE_STAGE_UNKNOWN = 'unknown'
const KIDNEY_DISEASE_STAGE_ANSWERS = new Set([
  KIDNEY_DISEASE_STAGE_1_2,
  KIDNEY_DISEASE_STAGE_3_4,
  KIDNEY_DISEASE_STAGE_UNKNOWN,
])

// Which of these have you experienced? (when circulation condition was selected)
export const CIRCULATION_PROBLEM_TYPE_KEY = 'circulation_problem_type'
export const CIRCULATION_PROBLEM_TYPE_PERIPHERAL_VASCULAR_DISEASE =
  'peripheral_vascular_disease'
export const CIRCULATION_PROBLEM_TYPE_VASCULAR_ANEURYSMS = 'vascular_aneurysms'
export const CIRCULATION_PROBLEM_TYPE_OTHER = 'other'
const CIRCULATION_PROBLEM_TYPE_ANSWERS = new Set([
  CIRCULATION_PROBLEM_TYPE_PERIPHERAL_VASCULAR_DISEASE,
  CIRCULATION_PROBLEM_TYPE_VASCULAR_ANEURYSMS,
  CIRCULATION_PROBLEM_TYPE_OTHER,
])

// Have you ever been evaluated by your healthcare provider for peripheral vascular disease
// after initial diagnosis?
export const EVALUATED_FOR_PERIPHERAL_VASCULAR_DISEASE_KEY =
  'evaluated_for_peripheral_vascular_disease'
export const FOLLOWING_TREATMENT_FOR_PERIPHERAL_VASCULAR_DISEASE_KEY =
  'following_treatment_for_peripheral_vascular_disease'

// Details about Vascular or aortic aneurysms
export const VASCULAR_ANEURYSMS_DETAILS_KEY = 'vascular_aneurysms_details'

// Which of these have you experienced? (when eye condition was selected)
export const EYE_CONDITION_TYPE_KEY = 'eye_condition_type'
export const EYE_CONDITION_TYPE_RETINITIS = 'retinitis'
export const EYE_CONDITION_TYPE_AION = 'aion'
export const EYE_CONDITION_TYPE_VISION_LOSS_HISTORY = 'vision_loss_history'
export const EYE_CONDITION_TYPE_CENTRAL_SEROUS = 'central_serous'
export const EYE_CONDITION_TYPE_GLAUCOMA = 'glaucoma'
export const EYE_CONDITION_TYPE_OTHER = 'other'
const EYE_CONDITION_TYPE_ANSWERS = new Set([
  EYE_CONDITION_TYPE_RETINITIS,
  EYE_CONDITION_TYPE_AION,
  EYE_CONDITION_TYPE_VISION_LOSS_HISTORY,
  EYE_CONDITION_TYPE_CENTRAL_SEROUS,
  EYE_CONDITION_TYPE_GLAUCOMA,
  EYE_CONDITION_TYPE_OTHER,
])

export const EYE_CONDITION_RETINITIS_DETAILS_KEY = 'retinitis_details'
export const EYE_CONDITION_AION_DETAILS_KEY = 'aion_details'
export const EYE_CONDITION_VISION_LOSS_HISTORY_DETAILS_KEY =
  'vision_loss_history_details'
export const EYE_CONDITION_CENTRAL_SEROUS_DETAILS_KEY = 'central_serous_details'

// What type of glaucoma do you have?
export const GLAUCOMA_TYPE_KEY = 'glaucoma_type'
export const GLAUCOMA_TYPE_OPEN_ANGLE = 'open_angle'
export const GLAUCOMA_TYPE_NARROW_ANGLE = 'narrow_angle'
export const GLAUCOMA_TYPE_OTHER = 'other'
export const GLAUCOMA_TYPE_UNKNOWN = 'unknown'
const GLAUCOMA_TYPE_ANSWERS = new Set([
  GLAUCOMA_TYPE_OPEN_ANGLE,
  GLAUCOMA_TYPE_NARROW_ANGLE,
  GLAUCOMA_TYPE_OTHER,
  GLAUCOMA_TYPE_UNKNOWN,
])

// Have you received laser treatment for your glaucoma?
export const RECEIVED_LASER_FOR_GLAUCOMA_KEY = 'received_laser_for_glaucoma'
export const RECEIVED_LASER_FOR_GLAUCOMA_YES = 'yes'
export const RECEIVED_LASER_FOR_GLAUCOMA_NO = 'no'
export const RECEIVED_LASER_FOR_GLAUCOMA_UNKNOWN = 'unknown'

// Other eye condition they have
export const EYE_CONDITION_OTHER_DETAILS_KEY = 'eye_condition_other_details'

// Which of these have you experienced? (when penis condition was selected)
export const PENIS_OR_PROSTATE_CONDITION_TYPE_KEY = 'penis_condition_type'
export const PENIS_OR_PROSTATE_CONDITION_TYPE_PROSTATE_CONDITION =
  'prostate_condition'
export const PENIS_OR_PROSTATE_CONDITION_TYPE_PENIS_CONDITION =
  'penis_condition'
export const PENIS_OR_PROSTATE_CONDITION_TYPE_OTHER = 'other'
const PENIS_OR_PROSTATE_CONDITION_TYPE_ANSWERS = new Set([
  PENIS_OR_PROSTATE_CONDITION_TYPE_PROSTATE_CONDITION,
  PENIS_OR_PROSTATE_CONDITION_TYPE_PENIS_CONDITION,
  PENIS_OR_PROSTATE_CONDITION_TYPE_OTHER,
])

// Which of the following prostate conditions do you have? (43a. was selected)
export const PROSTATE_CONDITION_TYPE_KEY = 'prostate_condition_type'
export const PROSTATE_CONDITION_TYPE_PROSTATE_CANCER = 'prostate_cancer'
export const PROSTATE_CONDITION_TYPE_ENLARGED_PROSTATE = 'enlarged_prostate'
export const PROSTATE_CONDITION_TYPE_OTHER = 'other'
const PROSTATE_CONDITION_TYPE_ANSWERS = new Set([
  PROSTATE_CONDITION_TYPE_PROSTATE_CANCER,
  PROSTATE_CONDITION_TYPE_ENLARGED_PROSTATE,
  PROSTATE_CONDITION_TYPE_OTHER,
])

// Was your prostate cancer diagnosed within the last 5 years?
export const PROSTATE_CANCER_DIAGNOSED_IN_LAST_5_YEARS_KEY =
  'prostate_cancer_diagnosed_in_last_5_years'

// Which of the following penis conditions other than ED do you have?
export const PENIS_CONDITION_TYPE_KEY = 'penis_condition_type'
export const PENIS_CONDITION_TYPE_PEYRONIE_DISEASE = 'peyronie_disease'
export const PENIS_CONDITION_TYPE_PAINFUL_ERECTIONS = 'painful_erections'
export const PENIS_CONDITION_TYPE_BROKEN_PENIS = 'broken_penis'
export const PENIS_CONDITION_TYPE_PRIAPISM = 'priapism'
export const PENIS_CONDITION_TYPE_OTHER = 'other'
const PENIS_CONDITION_TYPE_ANSWERS = new Set([
  PENIS_CONDITION_TYPE_PEYRONIE_DISEASE,
  PENIS_CONDITION_TYPE_PAINFUL_ERECTIONS,
  PENIS_CONDITION_TYPE_BROKEN_PENIS,
  PENIS_CONDITION_TYPE_PRIAPISM,
  PENIS_CONDITION_TYPE_OTHER,
])

// Does the mark or curve prevent you from having sex? Is it painful?
// Have you sought treatment for this? If so, what kind of treatment did you receive?
export const PEYRONIE_DISEASE_DETAILS_KEY = 'peyronie_disease_details'

// Other penis condition details
export const PENIS_CONDITION_PAINFUL_ERECTIONS_DETAILS_KEY =
  'painful_erections_details'
export const PENIS_CONDITION_BROKEN_PENIS_DETAILS_KEY = 'broken_penis_details'
export const PENIS_CONDITION_PRIAPISM_DETAILS_KEY = 'priapism_details'
export const PENIS_CONDITION_OTHER_DETAILS_KEY = 'penis_condition_other_details'
// Other urology condition details
export const OTHER_UROLOGY_CONDITION_DETAILS_KEY =
  'other_urology_condition_details'

// Which of these have you experienced? (when brain problem was selected)
export const BRAIN_PROBLEM_TYPE_KEY = 'brain_problem_type'
export const BRAIN_PROBLEM_TYPE_STROKE = 'stroke'
export const BRAIN_PROBLEM_TYPE_PARALYSIS = 'paralysis'
export const BRAIN_PROBLEM_TYPE_SEIZURES = 'seizures'
export const BRAIN_PROBLEM_TYPE_OTHER = 'other'
const BRAIN_PROBLEM_TYPE_ANSWERS = new Set([
  BRAIN_PROBLEM_TYPE_STROKE,
  BRAIN_PROBLEM_TYPE_PARALYSIS,
  BRAIN_PROBLEM_TYPE_SEIZURES,
  BRAIN_PROBLEM_TYPE_OTHER,
])

// Have you ever been evaluated by your healthcare provider for your stroke, mini stroke, or
// TIA after initial diagnosis?
export const EVALUATED_FOR_STROKE_KEY = 'evaluated_for_stroke'
export const FOLLOWING_TREATMENT_FOR_STROKE_KEY =
  'following_treatment_for_stroke'

// What spinal cord level was your back or neck injury?
export const PARALYSIS_SPINAL_CORD_LEVEL_KEY = 'paralysis_spinal_cord_level'
export const PARALYSIS_SPINAL_CORD_LEVEL_T6_OR_HIGHER = 't6_or_higher'
export const PARALYSIS_SPINAL_CORD_LEVEL_T7_OR_LOWER = 't7_or_lower'
const PARALYSIS_SPINAL_CORD_LEVEL_ANSWERS = new Set([
  PARALYSIS_SPINAL_CORD_LEVEL_T6_OR_HIGHER,
  PARALYSIS_SPINAL_CORD_LEVEL_T7_OR_LOWER,
])

// Details about other neurological disease
export const OTHER_NEUROLOGICAL_DISEASE_DETAILS_KEY =
  'other_neurological_disease_details_key'

// Details about chronic medical conditions
export const CHRONIC_MEDICAL_CONDITIONS_DETAILS_KEY =
  'chronic_medical_conditions_details'

// Have you ever been diagnosed with a mental health or psychiatric condition?
export const DIAGNOSED_WITH_MENTAL_HEALTH_CONDITIONS =
  'diagnosed_with_mental_health'

// Which of the following mental health or psychiatric conditions do you have?
export const MENTAL_HEALTH_CONDITION_TYPE_KEY = 'mental_health_condition_type'
export const MENTAL_HEALTH_CONDITION_TYPE_DEPRESSION = 'depression'
export const MENTAL_HEALTH_CONDITION_TYPE_GAD = 'gad'
export const MENTAL_HEALTH_CONDITION_TYPE_BIPOLAR = 'bipolar'
export const MENTAL_HEALTH_CONDITION_TYPE_SCHIZO = 'schizophrenia'
export const MENTAL_HEALTH_CONDITION_TYPE_PANIC_DISORDER = 'panic_disorder'
export const MENTAL_HEALTH_CONDITION_TYPE_OTHER = 'other'
const MENTAL_HEALTH_CONDITION_TYPE_ANSWERS = new Set([
  MENTAL_HEALTH_CONDITION_TYPE_DEPRESSION,
  MENTAL_HEALTH_CONDITION_TYPE_GAD,
  MENTAL_HEALTH_CONDITION_TYPE_BIPOLAR,
  MENTAL_HEALTH_CONDITION_TYPE_SCHIZO,
  MENTAL_HEALTH_CONDITION_TYPE_PANIC_DISORDER,
  MENTAL_HEALTH_CONDITION_TYPE_OTHER,
])

// Have you ever been hospitalized for depression or attempted suicide?
export const BEEN_HOSPITALIZED_FOR_DEPRESSION = 'hospitalized_for_depression'

// Do you have or have you previously been diagnosed with any of the following heart conditions?
export const HEART_CONDITION_TYPE_KEY = 'heart_condition_type'
export const HEART_CONDITION_TYPE_ABNORMAL_HEART_BEATS = 'abnormal_heart_beats'
export const HEART_CONDITION_TYPE_IMPLANTED_ICD = 'implanted_icd'
export const HEART_CONDITION_TYPE_HEART_FAILURE = 'heart_failure'
export const HEART_CONDITION_TYPE_ARTERY_DISEASE = 'artery_disease'
export const HEART_CONDITION_TYPE_CORONARY_BYPASS_SURGERY =
  'coronary_bypass_surgery'
export const HEART_CONDITION_TYPE_CORONARY_ANGIOPLASTY = 'coronary_angioplasty'
export const HEART_CONDITION_TYPE_HEART_ATTACK = 'heart_attack'
export const HEART_CONDITION_TYPE_HOC =
  'hypertrophic_obstructive_cardiomyopathy'
export const HEART_CONDITION_TYPE_LONG_QT_SYNDROME = 'long_qt_syndrome'
export const HEART_CONDITION_TYPE_ELECTRICAL_HEART_ABNORMALITIES =
  'electrical_heart_abnormalities'
export const HEART_CONDITION_TYPE_NONE = 'none'
const HEART_CONDITION_TYPE_ANSWERS = new Set([
  HEART_CONDITION_TYPE_ABNORMAL_HEART_BEATS,
  HEART_CONDITION_TYPE_IMPLANTED_ICD,
  HEART_CONDITION_TYPE_HEART_FAILURE,
  HEART_CONDITION_TYPE_ARTERY_DISEASE,
  HEART_CONDITION_TYPE_CORONARY_BYPASS_SURGERY,
  HEART_CONDITION_TYPE_CORONARY_ANGIOPLASTY,
  HEART_CONDITION_TYPE_HEART_ATTACK,
  HEART_CONDITION_TYPE_HOC,
  HEART_CONDITION_TYPE_LONG_QT_SYNDROME,
  HEART_CONDITION_TYPE_ELECTRICAL_HEART_ABNORMALITIES,
  HEART_CONDITION_TYPE_NONE,
])

// What type of heart arrhythmia (abnormal heart beats) or heart-related diagnosis do you have?
export const ABNORMAL_HEART_BEATS_DETAILS_KEY = 'abnormal_heart_beats_details'

// Have you been admitted to the hospital or had an emergency room visit related to heart
// failure within the past year?
export const ADMITTED_TO_HOSPITAL_FOR_HEART_FAILURE_KEY =
  'admitted_to_hospital_for_heart_failure'

// When was your most recent heart attack?
export const MOST_RECENT_HEART_ATTACK_DATE_KEY = 'most_recent_heart_attack_date'
export const MOST_RECENT_HEART_ATTACK_LESS_THAN_3_MONTHS_AGO =
  'less_than_3_months_ago'
export const MOST_RECENT_HEART_ATTACK_3_6_MONTHS_AGO = '3_6_months_ago'
export const MOST_RECENT_HEART_ATTACK_MORE_THAN_6_MONTHS_AGO =
  'more_than_6_months_ago'
const MOST_RECENT_HEART_ATTACK_ANSWERS = new Set([
  MOST_RECENT_HEART_ATTACK_LESS_THAN_3_MONTHS_AGO,
  MOST_RECENT_HEART_ATTACK_3_6_MONTHS_AGO,
  MOST_RECENT_HEART_ATTACK_MORE_THAN_6_MONTHS_AGO,
])

// Do you have any other medical conditions you haven’t shared with us?
export const OTHER_MEDICAL_CONDITIONS_KEY = 'other_medical_conditions'
export const OTHER_MEDICAL_CONDITIONS_DETAILS_KEY =
  'other_medical_condition_details'

// Do you take any prescription or non-prescription medications or supplements to improve your
// mental health?
export const TAKING_MEDS_FOR_MENTAL_HEALTH_KEY = 'taking_meds_for_mental_health'
export const MEDS_FOR_MENTAL_HEALTH_DETAILS_KEY =
  'meds_for_mental_health_details'

// Are you taking any other medications, vitamins or supplements that you haven’t already told
// us about?
export const OTHER_MEDS_KEY = 'other_meds'
export const OTHER_MEDS_DETAILS_KEY = 'other_meds_details'

// Do you have any allergies to the following?
export const ALLERGIC_TO_KEY = 'allergic_to'
export const ALLERGIC_TO_MEDICATIONS = 'medications'
export const ALLERGIC_TO_SUPPLEMENTS = 'supplements'
export const ALLERGIC_TO_FOOD = 'food'
export const ALLERGIC_TO_SEASONAL = 'seasonal'
export const ALLERGIC_TO_NONE = 'none'
const ALLERGIC_TO_ANSWERS = new Set([
  ALLERGIC_TO_MEDICATIONS,
  ALLERGIC_TO_SUPPLEMENTS,
  ALLERGIC_TO_FOOD,
  ALLERGIC_TO_SEASONAL,
  ALLERGIC_TO_NONE,
])

export const MEDICATION_ALLERGY_DETAILS_KEY = 'medication_allergy_details'
export const SUPPLEMENT_ALLERGY_DETAILS_KEY = 'supplement_allergy_details'
export const FOOD_ALLERGY_DETAILS_KEY = 'food_allergy_details'
export const SEASONAL_ALLERGY_DETAILS_KEY = 'seasonal_allergy_details'

// Have you had any surgeries or medical procedures
export const HAD_SURGERIES_OR_MEDICAL_PROCEDURES_KEY =
  'had_surgeries_or_medical_procedures'

// Please tell us the dates and reasons for your surgeries or medical procedures.
export const SURGERY_DETAILS_KEY = 'surgery_details'

// Do you currently have or have you ever regularly smoked cigarettes?
export const SMOKING_HABITS_KEY = 'smoking_habits'
export const SMOKING_HABITS_MOST_DAYS = 'most_days'
export const SMOKING_HABITS_QUIT = 'quit'
export const SMOKING_HABITS_NEVER_STARTED = 'never_started'
const SMOKING_HABITS_ANSWERS = new Set([
  SMOKING_HABITS_MOST_DAYS,
  SMOKING_HABITS_QUIT,
  SMOKING_HABITS_NEVER_STARTED,
])

// Have you ever taken any of the following recreational drugs in the past 6 months?
export const DRUG_USE_IN_PAST_6_MONTHS_KEY = 'taken_drugs_in_past_6_months'
export const DRUG_USE_POPPER = 'popper'
export const DRUG_USE_COCAINE = 'cocaine'
export const DRUG_USE_METH = 'meth'
export const DRUG_USE_MOLLY = 'molly'
export const DRUG_USE_CANNABIS = 'cannabis'
export const DRUG_USE_OTHER = 'other'
export const DRUG_USE_NONE = 'none'
const DRUG_USE_ANSWERS = new Set([
  DRUG_USE_POPPER,
  DRUG_USE_COCAINE,
  DRUG_USE_METH,
  DRUG_USE_MOLLY,
  DRUG_USE_CANNABIS,
  DRUG_USE_OTHER,
  DRUG_USE_NONE,
])

export const DRUG_USE_POPPER_ACK_KEY = 'drug_use_popper_ack'
export const DRUG_USE_POPPER_FREQUENCY_KEY = 'drug_use_popper_frequency'
export const DRUG_USE_POPPER_CAPABLE_TO_STOP_KEY =
  'drug_use_popper_capable_to_stop'

export const DRUG_USE_COCAINE_ACK_KEY = 'drug_use_cocaine_ack'
export const DRUG_USE_COCAINE_FREQUENCY_KEY = 'drug_use_cocaine_frequency'
export const DRUG_USE_COCAINE_CAPABLE_TO_STOP_KEY =
  'drug_use_cocaine_capable_to_stop'

export const DRUG_USE_METH_ACK_KEY = 'drug_use_meth_ack'
export const DRUG_USE_METH_FREQUENCY_KEY = 'drug_use_meth_frequency'
export const DRUG_USE_METH_CAPABLE_TO_STOP_KEY = 'drug_use_meth_capable_to_stop'

export const DRUG_USE_MOLLY_ACK_KEY = 'drug_use_molly_ack'
export const DRUG_USE_MOLLY_FREQUENCY_KEY = 'drug_use_molly_frequency'
export const DRUG_USE_MOLLY_CAPABLE_TO_STOP_KEY =
  'drug_use_molly_capable_to_stop'

export const DRUG_USE_OTHER_DETAILS_KEY = 'drug_user_other_details'
export const DRUG_USE_OTHER_FREQUENCY_KEY = 'drug_use_other_frequency'
export const DRUG_USE_OTHER_CAPABLE_TO_STOP_KEY =
  'drug_use_other_capable_to_stop'

export const DRUG_USE_FREQUENCY_ONCE_OR_TWICE = 'once_or_twice'
export const DRUG_USE_FREQUENCY_THREE_OR_MORE = 'three_or_more'
const DRUG_USE_FREQUENCY_ANSWERS = new Set([
  DRUG_USE_FREQUENCY_ONCE_OR_TWICE,
  DRUG_USE_FREQUENCY_THREE_OR_MORE,
])

// Nitrate acknowledgement
export const NITRATE_ACKNOWLEDGEMENT_KEY = 'nitrate_acknowledgement'

// Is there anything else your provider should know or any questions you want to ask?
export const EXTRA_DETAILS_FOR_PROVIDER = 'extra_details_for_provider'
